import { formatCurrency } from '../utils/api';
import PriceSourceBadge from './PriceSourceBadge';

// Mobile (≤640px) replacement for the document's פריטים table: the shared
// .m-row anatomy — description on the start side, the line total on the end
// side so amounts align down the list, and qty × unit price (plus discount /
// SKU when present) as the meta line. A 13-column table scrolled sideways on a
// phone; everything the table carries still has a place here. Rows are
// static (a div, not ListRow's button) because an item leads nowhere.
//
// `netPrice` is the page's own net-unit calc, passed in so this list and the
// desktop table can never disagree about it.
export default function DocItemsList({ items, netPrice }) {
  return (
    <div className="m-list doc-items-list">
      {items.map((item, i) => {
        const disc = item.discount || 0;
        const isPct = item.discount_type !== 'amount';
        const creditTotal = item.credit_total || 0;
        const hasCredit = (item.credit_qty || 0) > 0 || (item.credit_price_diff || 0) > 0;
        const payable = (item.line_total || 0) - creditTotal;
        return (
          <div key={item.id ?? i} className={`m-row m-row--static${hasCredit ? ' is-warn' : ''}`}>
            <div className="m-row-main">
              <div className="m-row-primary">{item.description || '—'}</div>
              <div className="m-row-meta">
                <span>{item.qty} × {formatCurrency(item.unit_price)}</span>
                <PriceSourceBadge item={item} />
                {disc > 0 && (
                  <span>
                    הנחה {isPct ? `${disc}%` : formatCurrency(disc)} · נטו {formatCurrency(netPrice(item))}
                  </span>
                )}
                {(item.deposit || 0) > 0 && <span>פיקדון {formatCurrency(item.deposit)}</span>}
                {(item.purchase_tax || 0) > 0 && <span>מס קנייה {formatCurrency(item.purchase_tax)}</span>}
                {item.sku && <span>מק"ט {item.sku}</span>}
              </div>
            </div>
            <div className="m-row-end">
              <span className="m-row-amount">{formatCurrency(item.line_total)}</span>
              {/* Two lines, so a phone never squeezes the description; "אחרי
                  זיכוי", not "לתשלום" — this is a pre-VAT line amount, not
                  money owed. */}
              {hasCredit && (
                <span className="doc-items-credit">
                  <span>זיכוי {formatCurrency(creditTotal)}</span>
                  <span>אחרי זיכוי {formatCurrency(payable)}</span>
                </span>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
